import { Injectable } from '@angular/core';
import { HttpClient,  } from '@angular/common/http';
import { Observable,  } from 'rxjs';
import { map,  } from 'rxjs/operators';
import { GetviewBO } from './vieweligibility271.model';
import { ErrorService } from 'src/app/service/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
@Injectable({
  providedIn: 'root'
})
export class Eligibility271Service extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public outputValues(state: GetviewBO): void {
    this.getList(state).subscribe(x => super.next(x));
  }
  getList(state?: GetviewBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/ClaimProcess/GetEligibilitySummaryList", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['edi271clientlist'],
            count: response['totalCount'],
            clients: response['idarray'],
            validclients: response['validClientIds']
          }
      ));
  }
}